import React from 'react';
import { useFrontload } from 'react-frontload';
import { useDispatch } from 'react-redux';
import { fetchOrganizations } from '../../redux/organizations';
import { OrgsList } from './orgs_list';

const OrgsListContainer = () => {
  const dispatch = useDispatch();

  useFrontload(`OrgsListContainer`, async () => {
    await dispatch(fetchOrganizations());

    return true;
  });

  return <OrgsList />;
};

export default OrgsListContainer;
